[
  { "name": "cash", "label": "Cash", "tabler": "IconCash" },
  { "name": "coin", "label": "Coin", "tabler": "IconCoin" },
  { "name": "credit-card", "label": "Credit Card", "tabler": "IconCreditCard" },
  { "name": "receipt", "label": "Receipt", "tabler": "IconReceipt" },
  { "name": "report-money", "label": "Money Report", "tabler": "IconReportMoney" },
  { "name": "search", "label": "Magnifying Glass", "tabler": "IconSearch" },
  { "name": "forms", "label": "Form", "tabler": "IconForms" },
  { "name": "file-text", "label": "Document", "tabler": "IconFileText" },
  { "name": "checklist", "label": "Checklist", "tabler": "IconChecklist" },
  { "name": "writing-sign", "label": "Signature", "tabler": "IconWritingSign" },
  { "name": "gavel", "label": "Gavel", "tabler": "IconGavel" },
  { "name": "scale", "label": "Scales of Justice", "tabler": "IconScale" },
  { "name": "shield-check", "label": "Shield (Verified)", "tabler": "IconShieldCheck" },
  { "name": "lock", "label": "Lock", "tabler": "IconLock" },
  { "name": "user-check", "label": "Verified Person", "tabler": "IconUserCheck" },
  { "name": "users", "label": "Group of People", "tabler": "IconUsers" },
  { "name": "id", "label": "ID Card", "tabler": "IconId" },
  { "name": "mail", "label": "Envelope", "tabler": "IconMail" },
  { "name": "phone", "label": "Phone", "tabler": "IconPhone" },
  { "name": "clock", "label": "Clock", "tabler": "IconClock" },
  { "name": "hourglass", "label": "Hourglass", "tabler": "IconHourglass" },
  { "name": "calendar", "label": "Calendar", "tabler": "IconCalendarEvent" },
  { "name": "circle-check", "label": "Checkmark", "tabler": "IconCircleCheck" },
  { "name": "thumb-up", "label": "Thumbs Up", "tabler": "IconThumbUp" },
  { "name": "alert-triangle", "label": "Warning", "tabler": "IconAlertTriangle" },
  { "name": "help", "label": "Question Mark", "tabler": "IconHelpCircle" },
  { "name": "building-bank", "label": "Bank", "tabler": "IconBuildingBank" },
  { "name": "map-pin", "label": "Location Pin", "tabler": "IconMapPin" }
]
